import Actions from './action';

export const initState = {
	isdeliveryLoading: false,
	deliveryInfoData: [],
};

const deliveryInfoReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.DELIVERY_INFO_DATA_LOADING: {
			return {
				...state,
				isdeliveryLoading: action.payload.loading,
			};
		}
		case Actions.types.GET_DELIVERY_INFO_DATA_START: {
			return {
				...state,
				isdeliveryLoading: true,
			};
		}
		case Actions.types.GET_DELIVERY_INFO_DATA_SUCCESS: {
			console.log('SUCCESS', action.res.data);
			return {
				...state,
				isdeliveryLoading: false,
				deliveryInfoData: action.res.data,
			};
		}
		case Actions.types.GET_DELIVERY_INFO_DATA_ERROR: {
			return {
				...state,
				isdeliveryLoading: false,
			};
		}
		default:
			return state;
	}
};

export default deliveryInfoReducer;
